/**
 * Valeurs régionales appliquées automatiquement à l’étape 2 du setup tant que le produit est
 * ciblé France. Les champs correspondants sont masqués dans l’UI ; une future internationalisation
 * réaffichera / personnalisera ces codes et le fuseau.
 */
export const SETUP_DEFAULT_LOCALE = {
  countryCode: 'FR',
  currencyCode: 'EUR',
  languageCode: 'fr-FR',
} as const;

export const SETUP_DEFAULT_TIME_ZONE = 'Europe/Paris';
